import { creatorEconomyApi } from '../utils'
import { apiRequest, socialApiRequest } from './apiWrapper'

export const CREATE_HOME_PAGE_ID = '18475857-82f7-4b72-8726-76d7f0973927'
const SUPER_APP_MENU_TITLE = 'super app'

const LANDING_HEADERS = {
  'x-version': '1.0.0',
  'x-appname': 'Eternal'
}

export async function homeApi() {
  const response = await apiRequest({
    method: 'get',
    url: 'homepage/',
    credentials: 'include'
  })
  return response
}

async function pageSectionWithItem(pageId, previewToken) {
  // In CMS preview the sections come from an unpublished payload resolved
  // server-side against the token, and must never be served from cache.
  const url = previewToken
    ? `landing/v1/preview/${encodeURIComponent(previewToken)}/section-with-item`
    : `landing/v1/section-with-item/page/${pageId}?count=100&include_inactive=false`

  const response = await apiRequest({
    method: 'get',
    url,
    headers: LANDING_HEADERS,
    skipCache: !!previewToken,
  })
  return response
}

export async function homePageSectionWithItem(previewToken) {
  return pageSectionWithItem(CREATE_HOME_PAGE_ID, previewToken)
}

// The Super App home page has a different id in each environment, so it's
// found through its landing menu: the "Super App" menu's first page.
// null when this environment has no such menu or page.
export async function superAppHomePageId() {
  const menus = await apiRequest({
    method: 'get',
    url: 'landing/v1/menu/list',
    headers: LANDING_HEADERS
  })
  const menu = menus?.data?.find(
    (m) => m?.title?.trim().toLowerCase() === SUPER_APP_MENU_TITLE
  )
  if (!menu) return null

  const pages = await apiRequest({
    method: 'get',
    url: `landing/v1/page/menu/${menu._id}`,
    headers: LANDING_HEADERS
  })
  return pages?.data?.[0]?._id || null
}

export async function superAppHomeSectionWithItem(pageId, previewToken) {
  return pageSectionWithItem(pageId, previewToken)
}

export async function faceSwapPageSectionWithItem() {
  const response = await apiRequest({
    method: 'get',
    url: `landing/v1/section-with-item/page/a3f9c2e4-7b61-4d8f-9c52-1e6b8a4f7d90`,
    headers: {
      "x-version": '1.0.0',
      "x-appname": 'Eternal',
    },
  })
  return response
}
export async function motionControlPageSectionWithItem() {
  const response = await apiRequest({
    method: 'get',
    url: `landing/v1/section-with-item/page/9f3c2a1e-6b7d-4c82-9e5f-3a1d8c7b2f64`,
    headers: {
      "x-version": '1.0.0',
      "x-appname": 'Eternal',
    },
  })
  return response
}

export const fetchContentDetails = async (id, isUGC, NotYetPublish) => {

  if (NotYetPublish) {
    const response = await apiRequest({
      method: 'get',
      url: `contents/${id}`
    })
    return response
  }
  if (isUGC === true) {
    const response = await socialApiRequest({
      method: 'get',
      url: `content/${id}`
    })
    return response
  }
  if (isUGC === false) {
    const response = await creatorEconomyApi({
      method: 'get',
      url: `/templates/${id}`
    })
    return response?.data
  }

  try {
    const templateResponse = await creatorEconomyApi({
      method: 'get',
      url: `/templates/${id}`
    })
    if (templateResponse?.data) {
      return { ...templateResponse.data, is_ugc: false }
    }
  } catch (error) {
    try {
      const socialResponse = await socialApiRequest({
        method: 'get',
        url: `content/${id}`
      })
      if (socialResponse) {
        return { ...socialResponse, is_ugc: true }
      }
    } catch (socialError) {
      console.error('FetchContentDetails failed on both buckets:', socialError)
      throw socialError
    }
  }
}
export const fetchGenreInfoDetails = async () => {
  const response = await creatorEconomyApi({
    method: 'get',
    url: `/info/genre-list`
  })
  return response?.data
}

export async function superAppHomeApi() {
  const response = await apiRequest({
    method: 'get',
    url: 'v1/superapp_home/'
  })
  return response
}

// export async function superAppHomePendingDataApi() {
//   const response = await socialApiRequest({
//     method: 'get',
//     url: 'like_most_liked/?most_liked=true'
//   })
//   return response
// }

export async function superAppHomePendingDataApi(limit = 50, page = 1) {
  const response = await socialApiRequest({
    method: 'get',
    // url: 'feed/content_listing?name=home',
    url:'feed/latest_feed',
    params: { limit, page }
  })
  return response
}

export async function searchMetaContentApi(category) {
  const response = await apiRequest({
    method: 'get',
    url: 'search_meta_content/',
    params: { query: category }
  })
  return response
}
